/**
 * Point clustering utility.
 */
export class Clustering {
    constructor(maxRadius) {
        Object.defineProperty(this, "clusters", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "maxRadius", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.clusters = [];
        this.maxRadius = maxRadius;
    }
    /**
     * Create a new cluster.
     *
     * @param point
     * @returns
     */
    createCluster(point) {
        this.clusters.push({
            points: [point],
            centroid: point.clone(),
        });
        return this.clusters.length - 1;
    }
    /**
     * Add a point to an existing cluster.
     *
     * @param point
     * @param clusterID
     * @returns
     */
    updateCluster(point, clusterID) {
        const cluster = this.clusters[clusterID];
        // Compute the new centroid
        const n = cluster.points.length;
        cluster.centroid
            .multiplyScalar(n)
            .add(point)
            .divideScalar(n + 1);
        cluster.points.push(point);
        return clusterID;
    }
    /**
     * Cluster a point and get its cluster ID.
     *
     * @param point
     * @returns
     */
    add(point) {
        // Filter clusters by distance to point
        const clusterDistances = [];
        for (let i = 0; i < this.clusters.length; i++) {
            const distance = this.clusters[i].centroid.distanceTo(point);
            if (distance <= this.maxRadius) {
                clusterDistances.push([distance, i]);
            }
        }
        // Find closest cluster
        let minimum = clusterDistances[0];
        for (let i = 1; i < clusterDistances.length; i++) {
            if (clusterDistances[i][0] < minimum[0]) {
                minimum = clusterDistances[i];
            }
        }
        if (clusterDistances.length > 0) {
            return this.updateCluster(point, minimum[1]);
        }
        else {
            return this.createCluster(point);
        }
    }
    /**
     * Get the list of points in a cluster.
     *
     * @param clusterID
     * @returns
     */
    getCluster(clusterID) {
        if (clusterID >= 0 && clusterID < this.clusters.length) {
            return this.clusters[clusterID].points.map(p => p.clone());
        }
        else {
            return [];
        }
    }
    /**
     * Get the number of clusters.
     *
     * @returns
     */
    getClusterCount() {
        return this.clusters.length;
    }
    /**
     * Clear all clusters. This will invalidate existing IDs
     */
    clear() {
        this.clusters = [];
    }
}
